import { Binning, LineData } from "./binning";
import { StructureTensorScanner } from "./structure-tensor-scanner";

export interface SelectedLineAnalysisParams {
    lines: LineData[];
    width: number;
    height: number;
    binResolution: number;
}

export interface SelectedLineAnalysisResult {
    lineImportances: Float32Array;
}

export function analyzeSelectedLines(
    params: SelectedLineAnalysisParams
): SelectedLineAnalysisResult {
    const { lines, width, height, binResolution } = params;
    const analysisBinResolution = Math.max(1, Math.floor(binResolution));
    const analysisWidth = Math.max(1, Math.ceil(width / analysisBinResolution));
    const analysisHeight = Math.max(1, Math.ceil(height / analysisBinResolution));
    const analysisLines = analysisBinResolution === 1
        ? lines
        : lines.map((line) => ({
            ...line,
            xValues: line.xValues.map((x) => x / analysisBinResolution),
            yValues: line.yValues.map((y) => y / analysisBinResolution),
        }));

    const selectedBinning = new Binning(
        analysisWidth,
        analysisHeight,
        1,
        1
    );
    selectedBinning.executeBinning(analysisLines, [[1]]);

    const [binCountX, binCountY] = selectedBinning.getBinCounts();
    const selectedScanner = new StructureTensorScanner(binCountX, binCountY);
    selectedScanner.initField(selectedBinning, analysisLines, 1, true);

    return {
        lineImportances: selectedScanner.computeLineImportances()
    };
}
